"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtOpenedEye = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtOpenedEye = function SvgBtOpenedEye(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.8983 13.6891C21.7554 13.4935 18.3496 8.90137 13.9999 8.90137C9.65019 8.90137 6.24431 13.4935 6.10153 13.6889C5.96616 13.8744 5.96616 14.126 6.10153 14.3115C6.24431 14.507 9.65019 19.0992 13.9999 19.0992C18.3496 19.0992 21.7554 14.507 21.8983 14.3116C22.0339 14.1262 22.0339 13.8744 21.8983 13.6891ZM13.9999 18.0442C10.7959 18.0442 8.02085 14.9963 7.19938 13.9999C8.01979 13.0026 10.789 9.95631 13.9999 9.95631C17.2038 9.95631 19.9787 13.0037 20.8005 14.0006C19.9801 14.9979 17.2108 18.0442 13.9999 18.0442Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.9999 10.835C12.2549 10.835 10.8351 12.2547 10.8351 13.9998C10.8351 15.7449 12.2549 17.1647 13.9999 17.1647C15.745 17.1647 17.1648 15.7449 17.1648 13.9998C17.1648 12.2547 15.745 10.835 13.9999 10.835ZM13.9999 16.1097C12.8365 16.1097 11.8901 15.1632 11.8901 13.9998C11.8901 12.8364 12.8365 11.8899 13.9999 11.8899C15.1633 11.8899 16.1098 12.8364 16.1098 13.9998C16.1098 15.1632 15.1634 16.1097 13.9999 16.1097Z",
    fill: "currentColor"
  }));
};

exports.SvgBtOpenedEye = SvgBtOpenedEye;